import React from 'react';
import { Link } from 'react-router-dom';

export const getPropertyTypeLabel = (type) => {
  if (type === 'both') return 'Venta y Alquiler';
  if (type === 'sale') return 'Venta';
  if (type === 'rent') return 'Alquiler';
  return '';
};

export const propertyPath = (property) => `/propiedades/${property.slug}`;

// priority: foto visible al abrir la página (se carga ya y con prioridad alta);
// el resto se difiere hasta acercarse a la pantalla.
const PropertyCard = ({ property, priority = false }) => {
  const path = propertyPath(property);

  return (
    <div className="property-card">
      {property.status === 'sold' && (
        <div className="property-badge sold">VENDIDA</div>
      )}
      {property.featured && property.status !== 'sold' && (
        <div className="property-badge featured">DESTACADA</div>
      )}
      <div className="property-image">
        <img
          src={property.thumb || property.image}
          alt={`${property.title} en ${property.address} - J&K Realty Quito`}
          width="800"
          height="600"
          loading={priority ? 'eager' : 'lazy'}
          decoding="async"
          fetchpriority={priority ? 'high' : 'low'}
        />
        <Link to={path} className="property-overlay" aria-label={`Ver detalles de ${property.title}`}>
          <span className="btn-view">Ver Detalles</span>
        </Link>
      </div>
      <div className="property-details">
        <div className="property-price">{property.price || getPropertyTypeLabel(property.type)}</div>
        <h3 className="property-title"><Link to={path}>{property.title}</Link></h3>
        <p className="property-address">{property.address}</p>
        {property.snippet && (
          <p className="property-snippet">{property.snippet}</p>
        )}
      </div>
    </div>
  );
};

export default PropertyCard;
